import React from "react";
import { useNavigate } from "react-router-dom";
import { AccountSettingSVG, SignOutSVG } from "../svgsMobile";
import { useFetchUserData } from "../hooks/user/useFetchUserData";
import SignOut from "./ProfileTray/SignOut";
import { UserAuth } from "../Context";
import Options from "./ProfileTray/Options";
const Profile = ({ closeTray }) => {
  const { user } = UserAuth();
  const { userData } = useFetchUserData(user?.uid);
  const navigate = useNavigate();

  const handleImageError = (e) => {
    const avatarInitials = userData?.userName
      ? userData?.userName[0]?.toUpperCase()
      : userData?.displayName?.toUpperCase();
    e.target.onerror = null; // Prevents infinite loop in case fallback also fails
    e.target.src = `https://ui-avatars.com/api/?name=${avatarInitials}`;
  };
  return (
    <div>
      {/* Header */}
      <div
        onClick={() => {
          navigate(`/userProfile/${user?.uid}/shoppinglist`);
          closeTray();
        }}
        style={{ padding: "8px 0px" }}
        className="d-flex w-100 align-items-center justify-content-between"
      >
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          <div
            className="avatar"
            style={{
              height: "50px",
              width: "50px",
            }}
          >
            <img
              className={`avatar-img`}
              src={userData?.photo}
              alt=""
              onError={handleImageError}
              loading="lazy"
              style={{
                cursor: "pointer",
                borderRadius: "6px",
              }}
            />
          </div>
          <div>
            <div
              style={{
                fontSize: "18px",
                fontFamily: "Inter",
                fontWeight: 600,
                letterSpacing: "0%",
                color: "black",
              }}
            >
              {user?.displayName}
            </div>
            <div
              className="textColor"
              style={{ fontSize: "14px", fontWeight: 400 }}
            >
              View Profile
            </div>
          </div>
        </div>
        <svg
          width="26"
          height="27"
          viewBox="0 0 26 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.376465" width="26" height="26" rx="13" fill="#E3E3E9" />
          <path
            d="M11 18L16 13L11 8"
            stroke="#676A79"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      {/* Body */}
      <div
        className="d-flex flex-column"
        style={{
          paddingTop: "12px",
          gap: "12px",
        }}
      >
        {/* Links */}
        <div className="d-flex flex-column" style={{ gap: "8px" }}>
          <Options
            SVG={AccountSettingSVG}
            route={"/settings/accountSetting"}
            text={"Profile Settings"}
            closeTray={closeTray}
          />
          <SignOut
            SVG={SignOutSVG}
            route={"/SignIn"}
            text={"Sign Out"}
            closeTray={closeTray}
          />
        </div>
        {/* Cancel Button */}
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={closeTray}
          style={{
            width: "100%",
            height: "42px",
            borderRadius: "8px",
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              fontFamily: "Inter",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#676A79",
            }}
          >
            Cancel
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
